import { UserService } from "Services";

function shipmentsSingleBookingInfoController($scope: any) {
  $scope.isEmployee = UserService.isEmployeeOrAgent();
}

shipmentsSingleBookingInfoController.$inject = ["$scope"];
export default shipmentsSingleBookingInfoController;
